import { lazy } from 'react'

export const Layout = lazy(() => import('./layout'))
export const AsContributor = lazy(() => import('./as-contributor'))
export const AsCommenter = lazy(() => import('./as-commenter'))
